<template>
  <div class="slider-inner slider-j">
    <Logo />

    <img class="j1 animated zoomIn" src="~images/j/j_2.png" />
    <div class="j2 animated fadeInUpBig">
      <img class="j2_1 animated fadeIn" src="~images/j/j_12.png" alt="" />
      <img class="j2_2 animated fadeInLeft" src="~images/j/j_8.png" alt="" />
      <img class="j2_3 animated fadeInUp" src="~images/j/j_13.png" alt="" />
      <img class="j2_4 animated fadeInLeft" src="~images/j/j_9.png" alt="" />
      <img class="j2_5 animated zoomIn" src="~images/j/j_14.png" alt="" />
      <a
        class="j2_6 animated zoomIn"
        href="https://xym.51job.com/wechat/vuectmjobs/#/index?id=4a375bb5-cb6b-4a6a-bff2-a02e8c9bce9c&color=31BE88"
        target="_blank"
      >
        <img src="~images/j/j_11.png" alt="" />
      </a>

      <div class="j2_7 animated zoomIn">
        <img class="animated pulse" src="~images/j/j_7.png" alt="" />
      </div>
    </div>
    <img class="j3 animated fadeInLeft" src="~images/j/j_6.png" alt="" />
    <img class="j4 animated fadeInRight" src="~images/j/j_5.png" alt="" />
    <img class="j5 animated fadeInLeft" src="~images/j/j_4.png" alt="" />
    <img class="j9 animated fadeInRight" src="~images/j/j_3.png" alt="" />
    <img class="j6 animated fadeInLeft" src="~images/j/j_left.png" alt="" />
    <img class="j7 animated fadeInRight" src="~images/j/j_right.png" alt="" />
    <img class="j8 animated fadeInUp" src="~images/j/j_1.png" alt="" />
    <!-- <Tip /> -->
  </div>
</template>

<script>
export default {
  name: "SliderJ",
};
</script>

<style lang="less" scoped>
.slider-j {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  background-size: 100% 100%;
  .j1 {
    width: 60%;
    position: absolute;
    top: 14%;
    left: 20%;
    z-index: 1;
    animation-delay: 0.4s;
  }
  .j2 {
    width: 90%;
    background: url("~images/j/j_10.png") center top / 100% no-repeat;
    position: absolute;
    top: 20%;
    left: 5%;
    box-sizing: border-box;
    padding: 0.5rem 0.15rem;
    .j2_1 {
      animation-delay: 0.6s;
      visibility: hidden;
    }
    .j2_2 {
      animation-delay: 0.8s;
    }
    .j2_4 {
      animation-delay: 1.2s;
    }
    .j2_2,
    .j2_4 {
      width: 1.92rem;
    }
    .j2_3 {
      margin: 0.3rem 0;
      animation-delay: 1s;
    }
    .j2_5 {
      animation-delay: 1.4s;
    }
    .j2_6 {
      width: 50%;
      margin: 0 auto 10px;
      animation-delay: 1.5s;
      display: block;
    }
    .j2_7 {
      width: 15%;
      position: absolute;
      right: 22%;
      bottom: 5%;
      animation-delay: 1.5s;
      img {
        width: 100%;
        animation-delay: 1.6s;
        animation-iteration-count: infinite;
      }
    }
  }
  .j3 {
    width: 0.53rem;
    position: absolute;
    top: 15%;
    left: 12%;
    animation-delay: 0.8s;
  }
  .j4 {
    width: 0.8rem;
    position: absolute;
    top: 43%;
    right: 2%;
    animation-delay: 0.8s;
  }
  .j5 {
    width: 0.77rem;
    position: absolute;
    top: 65%;
    left: 4%;
    animation-delay: 0.8s;
  }
  .j9 {
    width: 1.44rem;
    position: absolute;
    top: 16%;
    right: 0%;
    animation-delay: 0.8s;
  }
  .j6 {
    width: 3.65rem;
    position: absolute;
    bottom: -11%;
    left: 0%;
    animation-duration: 2s;
  }
  .j7 {
    width: 3.48rem;
    position: absolute;
    bottom: -11%;
    right: 0;
    animation-duration: 1.5s;
  }
  .j8 {
    width: 3.03rem;
    position: absolute;
    bottom: 2%;
    left: 30%;
    animation-delay: 1.8s;
  }
}
</style>
